import React, {useEffect, useState} from "react";
import {BrowserRouter, Route, useHistory} from 'react-router-dom'
import Trips from "./components/Trips";
import ViewTrip from "./components/ViewTrip";
import NflMapContainer from "./components/categories/NflMapContainer";
import AuthFireBase from "./components/utils/AuthFireBase";
import {onAuthStateChanged, getAuth, browserSessionPersistence} from "firebase/auth";
import {firebaseToken} from "./components/tokens";
import firebase from "firebase/compat/app";
import axios from "axios";
import {UserContext} from "./components/UserContext";
import ResponsiveAppBar from "./components/NavBar";
import Profile from "./components/Profile";
import Friends from "./components/Friends";
import UnitedStatesMapContainer from "./components/categories/UnitedStatesMapContainer";
import EuropeMap from "./components/categories/EuropeMap";
import EuropeMapContainer from "./components/categories/EuropeMapContainer";
import NationalParksMapContainer from "./components/categories/NationalParkMapContainer";
import NationalParksMapContainerFour from "./components/categories/NationalParkMapContainerFour";
import Logout from "./Logout";
import {getBearerToken, getServerUrl} from "./components/utils/utils";
import {confirmAlert} from "react-confirm-alert";
import MlbMapContainer from "./components/categories/MlbMapContainer";
import WorldMapContainer from "./components/categories/WorldMapContainer";


function App() {
    let history = useHistory();
    const [user, setUser] = useState()
    const [validatingUser, setValidatingUser] = useState(true);
    const [trips, setTrips] = useState([])
    const [secondAlert, setSecondAlert] = useState(false)

    useEffect(() => {
        if (secondAlert) {
            if (user?.id === 8) {
                setTimeout(() => {
                    confirmAlert({
                        title: 'Confirm Older Brother',
                        message: 'Is he super way cooler than you??',
                        buttons: [
                            {
                                label: 'Yes'
                            },
                            {
                                label: 'No',
                                onClick: () => {
                                    window.location.pathname = "/logout"
                                }
                            }
                        ]
                    });
                }, 250)
            } else if (user?.id === 15) {
                setTimeout(() => {
                    confirmAlert({
                        title: 'Confirm Brother-in-law',
                        message: 'Is he super way cooler than you??',
                        buttons: [
                            {
                                label: 'Yes'
                            },
                            {
                                label: 'No',
                                onClick: () => {
                                    window.location.pathname = "/logout"
                                }
                            }
                        ]
                    });
                }, 250)
            }
        }
    }, [secondAlert])

    useEffect(() => {
        const firebaseConfig = {
            apiKey: firebaseToken,
            authDomain: "mapapp-80251.firebaseapp.com",
            projectId: "mapapp-80251",
            storageBucket: "mapapp-80251.appspot.com",
            messagingSenderId: "150156146723",
            appId: "1:150156146723:web:8ef265f7e1c27ab4305996"
        };

// Initialize Firebase
        firebase.initializeApp(firebaseConfig);
        const auth = getAuth();
        auth.setPersistence(browserSessionPersistence)
        const unSubscribe = onAuthStateChanged(auth, user => {
            if (user) {
                setUser(user);
                axios.post(`${getServerUrl()}/user`, {
                    firebaseId: user.uid,
                    username: user.displayName,
                    email: user.email,
                }, {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                        Authorization: `Bearer ${user.accessToken}`
                    },
                }).then(response => {
                    const updatedUser = {...user}
                    updatedUser.id = response.data.id
                    updatedUser.displayName = response.data.username
                    updatedUser.profilePictureUrl = response.data.profilePictureUrl
                    updatedUser.profilePictureId = response.data.profilePictureId
                    setUser(updatedUser)
                    retrieveLatestTrips(updatedUser)
                    if (updatedUser?.id === 8) {
                        confirmAlert({
                            title: 'Confirm Older Brother',
                            message: 'Is your older brother Jimmie way cooler than you?',
                            buttons: [
                                {
                                    label: 'Yes'
                                },
                                {
                                    label: 'No',
                                    onClick: () => setSecondAlert(true)
                                }
                            ]
                        });
                    } else if (user?.id === 15){
                        confirmAlert({
                            title: 'Confirm Brother-in-law',
                            message: 'Is your brother-in-law Jimmie way cooler than you?',
                            buttons: [
                                {
                                    label: 'Yes'
                                },
                                {
                                    label: 'No',
                                    onClick: () => setSecondAlert(true)
                                }
                            ]
                        });
                    }
                });
            } else {
                setUser(null);
            }
            setValidatingUser(false); //<- here we change the validatingUser state
        });
        return () => unSubscribe();
    }, [])


    const retrieveLatestTrips = async user => {
        axios.get(`${getServerUrl()}/user/${user?.id}/trip`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setTrips(response.data)
            })
    }

    if (validatingUser) {
        return <div></div>
    }

    if (!user) {
        return (
            <UserContext.Provider value={{user: user, updateUser: updatedUser => setUser(updatedUser)}}>
                <AuthFireBase onUserLogin={loggedInUser => setUser(loggedInUser)}/>
            </UserContext.Provider>
        )
    } else {
        return (
            <UserContext.Provider value={{user: user, updateUser: updatedUser => setUser(updatedUser), allTrips: trips, retrieveLatestTrips: () => retrieveLatestTrips(user)}}>
                <div className="App">
                    <BrowserRouter>
                        <ResponsiveAppBar/>
                        <Route exact path="/">
                            <Trips/>
                        </Route>
                        <Route exact path="/create">
                            <ViewTrip/>
                        </Route>
                        <Route exact path="/nfl">
                            <NflMapContainer/>
                        </Route>
                        <Route exact path="/mlb">
                            <MlbMapContainer/>
                        </Route>
                        <Route exact path="/unitedStates">
                            <UnitedStatesMapContainer />
                        </Route>
                        <Route exact path="/world">
                            <WorldMapContainer />
                        </Route>
                        <Route exact path="/nationalParks">
                            <NationalParksMapContainerFour />
                        </Route>
                        <Route exact path="/europe">
                            <EuropeMapContainer />
                        </Route>
                        <Route exact path="/profile/:id">
                            <Profile/>
                        </Route>
                        <Route exact path="/friends">
                            <Friends/>
                        </Route>
                        <Route exact path="/logout">
                            <Logout/>
                        </Route>
                    </BrowserRouter>
                </div>
            </UserContext.Provider>
        );
    }
}

export default App;
